/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUser } from 'app/shared/model/user.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';
import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';

export interface IPharmacist {
  id?: string;
  education?: string | null;
  training?: string | null;
  experience?: string | null;
  achievements?: string | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  name?: string;
  email?: string;
  age?: number | null;
  gender?: keyof typeof Gender | null;
  mobile?: string | null;
  dateOfBirth?: number | null;
  bloodGroup?: keyof typeof BloodGroup | null;
  tmUser?: IUser;
  contactCode?: IContactDetails | null;
  pharmacy?: IPharmacy;
}

export const defaultValue: Readonly<IPharmacist> = {
  active: false,
};
